// extracted by mini-css-extract-plugin
module.exports = {"title":"chevron-box_title__3QfeK","box":"chevron-box_box__293Jo","content":"chevron-box_content__1fq9I"};